import { render } from "./BuildingTypeCreate.vue?vue&type=template&id=c6920384"
import script from "./BuildingTypeCreate.vue?vue&type=script&lang=js"
export * from "./BuildingTypeCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__